let util = require("handlebars-utils");

export default function(Handlebars) {

    Handlebars.registerHelper("append", function(str, suffix) {
        if (typeof str === "string" && typeof suffix === "string") {
            return str + suffix;
        }
        return str;
    });

    Handlebars.registerHelper("prepend", function(str, prefix) {
        return typeof str === "string" && typeof prefix === "string"
            ? (prefix + str)
            : str;
    });

    Handlebars.registerHelper("lowercase", function(str) {
        if (util.isObject(str) && str.fn) {
            return str.fn(this).toLowerCase();
        }
        if (!util.isString(str)) return "";
        return str.toLowerCase();
    });

    Handlebars.registerHelper("upper", function(str) {
        if (util.isObject(str) && str.fn) {
            return str.fn(this).toUpperCase();
        }
        if (!util.isString(str)) return "";
        return str.toUpperCase();
    });

    Handlebars.registerHelper("startsWith", function(str, char) {
        if (!util.isString(str)) return "";
        return str.startsWith(char);
    });

    Handlebars.registerHelper("endsWith", function(str, char){
        if (!util.isString(str)) return "";
        return str.endsWith(char);
    });

    Handlebars.registerHelper("stringFormat", function() {
        return Array.from(arguments).reduce(function(str, arg) {
            if (util.isString(arg)) {
                str += arg;
            }
            return str;
        }, "");
    });

    Handlebars.registerHelper("split", function(str, arg){
        let divider = arg.divider || '|';
        let index = arg.index || 0;
        let a = str.split(divider);
        return a[index];
    });

    Handlebars.registerHelper("replace", function(str, find, newStr){
        return str.replace(find, newStr);
    });

    Handlebars.registerHelper("stripTags", function( txt ){
        if(typeof txt == "undefined") return;
        var regexp = /<[\/\w]+>/g
        return txt.replace(regexp, '');
    });

    Handlebars.registerHelper('jsonStringify', function(context) {
        return JSON.stringify(context);
    });

}